module.exports = __webpack_public_path__ + "static/media/biotools-brand-small.d53895b6.png";